<label-pane [ngStyle]="{'background-color': content?.color || '#202945'}"
            [transparent]="true">
    <i class="inline-flex p-r-2 col-w"
       [ngClass]="content?.icon || 'icon-gift'"
       [style.font-size.em]="1.4"></i>
    <p class="col-w"
       *iCms="'copy' of content; content: 'html'"
       [style.line-height.em]="1">
    </p>
</label-pane>